import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Receipt, Calendar, Package, Hash, CheckCircle2, Clock } from "lucide-react";

/**
 * V1.20 · Modal detalle de facturas del alumno.
 * Se abre al hacer click en el chip "Factura" de la ficha o listado.
 */
export default function InvoicesDetailDialog({ open, onClose, student, invoices = [] }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="invoices-detail-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Receipt className="h-5 w-5 text-orange-500" />
            Facturas de {student?.name || "alumno"}
          </DialogTitle>
          <DialogDescription>
            {invoices.length === 0
              ? "Este alumno no tiene facturas registradas todavía."
              : `${invoices.length} factura${invoices.length === 1 ? "" : "s"} vinculada${invoices.length === 1 ? "" : "s"}.`}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 max-h-[60vh] overflow-y-auto pr-1">
          {invoices.map((inv) => (
            <div key={inv.id || inv.number || Math.random()}
                 data-testid={`invoice-detail-${inv.id || inv.number || "x"}`}
                 className={`rounded-xl border p-3 ${inv.emitted ? "border-emerald-200 bg-emerald-50/60" : "border-amber-200 bg-amber-50/60"}`}>
              <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                {inv.emitted ? (
                  <span className="inline-flex items-center gap-1 rounded-full bg-emerald-600 text-white text-[10px] font-bold px-2 py-0.5">
                    <CheckCircle2 className="h-3 w-3" /> Emitida
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 rounded-full bg-amber-500 text-white text-[10px] font-bold px-2 py-0.5">
                    <Clock className="h-3 w-3" /> Borrador
                  </span>
                )}
                <span className="font-mono font-bold text-neutral-900">
                  {inv.number || <span className="text-neutral-400 italic">Sin número</span>}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-2 text-xs">
                <div className="flex items-center gap-1.5">
                  <Calendar className="h-3 w-3 text-neutral-500" />
                  <span className="text-neutral-500">Fecha:</span>
                  <span className="font-semibold">{inv.date || "—"}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <Hash className="h-3 w-3 text-neutral-500" />
                  <span className="text-neutral-500">Clases:</span>
                  <span className="font-semibold font-mono">{inv.classes_included || 0}</span>
                </div>
                {inv.notes && (
                  <div className="col-span-2 flex items-start gap-1.5">
                    <Package className="h-3 w-3 text-neutral-500 mt-0.5" />
                    <div>
                      <span className="text-neutral-500">Concepto:</span>{" "}
                      <span className="text-neutral-800">{inv.notes}</span>
                    </div>
                  </div>
                )}
                {inv.duplicated_from && (
                  <div className="col-span-2 text-[10px] text-neutral-400 italic">
                    Duplicada de otra factura
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
